module.exports = __webpack_public_path__ + "fonts/NoirPro-Regular.83b98671.woff";